<template>
	<div>
    <div class="m_context plr">
		<el-row>
            <el-col :span="24">
              <el-form ref="addForm" id="addForm" :model="form" :rules="rules" label-width="12.5%">

                <el-form-item :label="$t('lin_global.otaName')" prop="name">
                  <el-input v-model="form.name"></el-input>
                </el-form-item>

                <el-form-item :label="$t('lin_global.version')" prop="version">
                  <el-input v-model="form.version"></el-input>
                  <div style="color: #8391a5;font-size:12px;line-height: 2;margin-top: 4px;">{{$t('lin_global.verTips1')}}</div>
                </el-form-item>
                <el-form-item :label="$t('lin_global.risk_desc')" prop="memo">
                  <el-input v-model="form.memo"></el-input>
                </el-form-item>
        <!--moidfy by sing,2017-09-06;取消OTA和ROM的区分，统一改为OTA更新-->
				<!--<el-form-item :label="$t('lin_global.xtlx')" prop="type">
				    <el-radio-group v-model="form.type">
				      <el-radio label="rom">{{$t('lin_global.syatemR')}}</el-radio>
				      <el-radio label="ota">{{$t('lin_global.sysjota')}}</el-radio>
				    </el-radio-group>
				</el-form-item>-->
				<el-form-item :label="$t('lin_global.selectWenjian')" prop="filePath">
				    <el-upload
					  class="upload-demo"
					  name="fileUpload"
					  drag
					  :action="action"
            :file-list="fileList"
					  :on-success="handleAvatarScucess"
						:on-error='uploadError'
					  :before-upload="beforeAvatarUpload">
					  <i class="el-icon-upload"></i>
					  <div class="el-upload__text">{{$t('lin_global.jwjtdcc')}}<em>{{$t('lin_global.djsc')}}</em></div>
					  <div class="el-upload__tip" slot="tip">{{$t('lin_global.qsczipwj')}}</div>
					</el-upload>
			    </el-form-item>
					<el-form-item :label="$t('app_udfiletype')" prop="">
					  <el-radio class="radio" v-model="udFileType" label="0">{{$t('app_ttPkg')}}</el-radio>
 					  <el-radio class="radio" v-model="udFileType" label="1">{{$t('app_dfPkg')}}</el-radio>
					</el-form-item>
					<el-form-item v-show='udFileType == 1' :label="$t('app_preversion')" prop="preVersion">
					  <el-input v-model="form.preVersion"></el-input>
            <div style="color: #8391a5;font-size:12px;line-height: 2;margin-top: 4px;">{{$t('lin_global.verTips')}}</div>
					</el-form-item>
				

                <el-form-item v-show='0' :label="$t('lin_global.qmzst')">
                  <el-checkbox v-model="checked" @change="check">{{$t('lin_global.sfsyzdqm')}}</el-checkbox>
                </el-form-item>

                <el-form-item :label="$t('lin_global.zdqds')" prop="mechanismId">
                    <!--<el-select id="mechanismId" v-model="form.mechanismId" filterable clearable :placeholder="$t('lin_global.place_areaid')" class="w_33">-->
                       <!--<el-option v-for="item in areaList" :label="item.mechanismname" :value="item.mechanismid">-->
                       <!--</el-option>-->
                    <!--</el-select>-->
                    <MechanismSelector :data="mechanismData" :mselect="true" :classs="'w_33'"></MechanismSelector>
                </el-form-item>

                <el-form-item>
                  <el-button @click="onCancel" id="onCancel">{{$t('lin_btn.cancel')}}</el-button>
                  <el-button type="primary" :loading="isSubmit" @click="onSubmit">{{$t('lin_btn.add')}}</el-button>
                </el-form-item>

              </el-form>
            </el-col>

          </el-row>
    </div>
	</div>
</template>
<script>
	import axios from 'axios'
    import { baseurl,urlAssets } from '../../api/url'
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  export default{
    components: {
      MechanismSelector
    },
		data(){
      var versionCheck = (rule, value, callback) => {

				if (this.udFileType == 0 && rule.field == 'preVersion') {
					callback();
					return
				}

        var rg = /^\d+(\.\d+)+$/;
        if(!(rg.test(value))){
          callback(new Error(this.$t('lin_global.bbhgsbd')));
        }else{
          callback();
				}
				
      };
      var that = this
			return{
        mechanismData: {
          placeholder: that.$t('lin_global.place_areaid'),
          callback (value) {
            that.form.mechanismId = value
//            that.cSelect(value)
          }
				},
				udFileType: '0',
        isSubmit: false,
				fileList: [],
				action:`${urlAssets.fileUrl}`,
				checked: false,
				dialogFormVisible: false,
				formLabelWidth: '100px',
				form:{
					name:'',
					md5: '',
					version:'',
					preVersion:'',
          memo:'',
					type:'ota',
					autoSign:'1',
					mechanismId:'',
					filePath:''
				},
				formEdit:{
					nickName:'',
					userName:'',
					phoneNum:'',
					userType:'',
					roleid:'',
					mechanismId:'',
					userStatus:'',
					userid:this.$route.params.id
				},
				isEdit:false,
				rules:{
					'name':[{
						required: true,
		            	message: this.$t('lin_global.notBlankName')
					}],
					'version':[{
						required: true,
		            	message: this.$t('lin_global.notBlankVer')
					},{
            validator: versionCheck, trigger: 'blur'
					}],
					'preVersion':[{
						required: true,
		            	message: this.$t('lin_global.notBlankVer')
					},{
            validator: versionCheck, trigger: 'blur'
          }],
					'type':[{
						required: true,
		            	message: this.$t('lin_global.qxzlx')
					}],
					'filePath':[{
						required: true,
		            	message: this.$t('lin_global.qxzscwj')
					}],
          'mechanismId':[{
            required: true,
            message: this.$t('lin_global.place_areaid')
          }]
				},
				areaList:[],
				roleList:[],
        already:false
			}
		},
		created(){ 
//			this.getAd();
			this.getRole();
			if(this.$route.params.id){
				this.isEdit = true;
				//console.log('编辑页面');
				this.getInfo();
			}else{
				this.isEdit = false;
				//console.log("添加页面");
			}
		},
    beforeRouteLeave (to, from, next) {
      // 导航离开该组件的对应路由时调用
      // 可以访问组件实例 `this`
			//alert(this.already)
			//alert('kao')
      if(this.already){
        this.$confirm(this.$t('lin_global.lkymtips'), this.$t('lin_btn.tips'), {
          confirmButtonText: this.$t('lin_btn.confirm'),
          cancelButtonText: this.$t('lin_btn.cancel'),
          type: 'warning'
        }).then(() => {
          next()
        }).catch(() => {
          return false
        });
      }else{
        next()
      }
    },
		methods:{
			uploadError () {
				this.already = false
			},
			check:function(){
				if(this.checked){
					this.form.autoSign = '0'
				}else{
					this.form.autoSign = '1'
				}
			},
      hBlur (name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
          } else {
            return false
          }
        })
      },
			handleAvatarScucess(res, file) {
        if (res.status === 200) {
          //console.log("打印上传后返回");
          //console.log(res);
					this.form.filePath = res.fileUrl;
					this.form.md5 = res.md5
          this.fileList = [{name: file.name}];
          this.hBlur('addForm');
          this.already = false;
          localStorage.removeItem("_isUploading");
        } else {
          if (!this.form.filePath) {
            this.fileList = []
          } else {
            this.fileList = [{name: this.makeAppPath(this.form.filePath)}]
          }
          this.$message.error(this.$t('lin_global.znscziptips'))
        }

		    },
      makeAppPath (url) {
        var path = url
        if (!path) {
          if (this.form) {
            path = this.form.filePath
          } else {
            return ''
          }
        }
        var arr = path.split('/')
        return arr[arr.length - 1]
      },
		    beforeAvatarUpload(file) {
			    this.already = true;
			    localStorage.setItem("_isUploading","true")
          if (file) {
            var ar = file.name.split('.')
            var type = ar[ar.length - 1]
            if (type === 'zip') {
              return true
            } else {
              this.$message.error(this.$t('lin_global.znscziptips'))
              return false
            }
          } else {
            this.$message.error(this.$t('lin_global.qsczipwj'))
            return false
          }
		    },
			chang:function(){
				//alert("nime")
				this.dialogFormVisible = true
			},
			submitForm(formName) {
		        this.$refs[formName].validate((valid) => {
		          if (valid) {
		            var params = {
                        userId:this.$route.params.id,
                        oldPwd:this.$sha256(this.formPwd.oldPass),
                        newPwd:this.$sha256(this.formPwd.checkPass)
                    }
		            //console.log("打印修改密码传参")
			        //console.log(params);
		            axios.post(`${baseurl}/user/updatePassword.do`,params).then(res=>{
			            //console.log("打印看看登陆信息")
			            //console.log(res.data);
			            if(res.data.status == 200){
			            	this.dialogFormVisible = false;
			            	this.$message.success(res.data.message);
			            }else{
			            	this.dialogFormVisible = false;
			            	this.$message.error(res.data.message)
			            }
			        })
		          } else {
		            //console.log('error submit!!');
		            return false;
		          }
		        });
		    },

			addInfo:function(){
				var params = this.form;
				params.updateType = this.udFileType
				params.md5 = this.form.md5
				
				//console.log("打印传入参数");
				//console.log(params)
        this.isSubmit = true;
				axios.post(`${baseurl}/ota_rom/add.do`,params).then(res=>{
		            //console.log("打印看看登陆信息")
		            //console.log(res.data);
		            if(res.data.status == 200){
		            	this.$message.success(res.data.message);
                  this.isSubmit = false;
		            	this.$router.go(-1);
		            }else{
                  this.isSubmit = false;
		            	this.$message.error(res.data.message)
		            }
		        })
			},
			onSubmitEdit:function(){
				var params = this.formEdit;
				//console.log("打印传入参数");
				//console.log(params)
				axios.post(`${baseurl}/user/editUser.do`,params).then(res=>{
		            //console.log("打印看看登陆信息")
		            //console.log(res.data);
		            if(res.data.status == 200){
		            	this.$message.success(res.data.message);
		            	//this.$router.go(-1);
		            }else{
		            	this.$message.error(res.data.message)
		            }
		        })
			},
			getInfo:function(){
				var userId = this.$route.params.id
				var params = {userId:userId};
				axios.post(`${baseurl}/user/getUserById.do`,params).then(res=>{
				//console.log("打印傻逼");
				//console.log(res.data.data)
		            this.formEdit.nickName = res.data.data.nickName;
		            this.formEdit.userName = res.data.data.userName;
		            this.formEdit.phoneNum = res.data.data.phoneNum;
		            this.formEdit.roleid = res.data.data.roleid;
		            this.formEdit.mechanismId = res.data.data.mechanismId;
		            this.formEdit.userStatus = res.data.data.userStatus;
		        })

			},
			onSubmit:function(){
				if (this.udFileType == 0) {
					this.form.preVersion = ' '
				}
				this.$refs['addForm'].validate((valid)=>{
					if(valid){
						this.addInfo()
					}else{
						this.$message.error(this.$t('lin_global.refs'))
            			return false
					}
				})
			},
			getAd:function(){
		    	var params = {page:1,rows:10000};
		    	axios.post(`${baseurl}/mechanism/list.do`,params).then(res=>{
		    		//console.log(res.data);
		    		/*var obj={
		    			'mechanismname':'所有渠道商通用',
		    			'mechanismid':''
		    		}*/
		    		this.areaList = res.data.data;

		    		//this.areaList.unshift(obj)
		    	})
		    },
		    getRole:function(){
		    	var mechanismId = localStorage.getItem('mechanismId');
		    	var params = {page:1,rows:10,distributorid:mechanismId};
		    	axios.post(`${baseurl}/role/list.do`,params).then(res=>{
		    		//console.log(res.data);
		    		this.roleList = res.data.data;
		    	})
		    },
			onCancel:function(){
				this.$router.go(-1);
			}
		}
	}
</script>



// WEBPACK FOOTER //
// romUpload.vue?3e11d306